import { downTrendGreen, upTrendRed } from 'common/assets/images';
import { fixedTwoDecimalOnlyPositiveValue } from 'common/utils/utilFunctions';

import styles from './RiskTaxonomyHeatMap.module.scss';

export const ReturnTrendWithIcon = (value: string) => {
	const iconValue = parseFloat(value);
	const positiveValue = fixedTwoDecimalOnlyPositiveValue(value);
	if (iconValue === 0.0) {
		return '';
	}
	if (iconValue > 0) {
		return (
			<span className={styles['red-trend']}>
				<img src={upTrendRed} draggable="false" alt="arrow up" />
				{positiveValue}
			</span>
		);
	}
	return (
		<span className={styles['green-trend']}>
			<img src={downTrendGreen} draggable="false" alt="arrow down" />
			{positiveValue}
		</span>
	);
};
